import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode'; // Correct import for jwtDecode

// Function to get the user role from the token stored in cookies
export const getUserRole = () => {
    const token = Cookies.get('access_token');
    if (token) {
        try {
            const decodedToken = jwtDecode(token);
            return decodedToken.label; // Assuming 'label' contains the role
        } catch (error) {
            console.error("Failed to decode token", error);
            return null;
        }
    }
    return null;
};

// Function to check user permissions
export const checkPermission = (requiredRole, userRole) => {
    if (!requiredRole) return false; // If no permission is required, do not display the route
    if (!userRole) return false;

    // Handle multiple roles separated by '||'
    const roles = requiredRole.split('||').map(r => r.trim());

    // Check if the user has one of the required roles
    return roles.some(role => role === userRole);
};